/**
 * NativeWaves Content API v1
 *
 * Contact: support@nativewaves.com
 *
 * DO NOT EDIT THIS CLASS MANUALLY!
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class AvcTasksApi extends runtime.BaseAPI {
    /**
     * Get audio/video coding tasks in bulk.
     */
    async avcTasksBatchGetPostRaw(requestParameters, initOverrides) {
        if (requestParameters.avcTaskBatchGet === null ||
            requestParameters.avcTaskBatchGet === undefined) {
            throw new runtime.RequiredError('avcTaskBatchGet', 'Required parameter requestParameters.avcTaskBatchGet was null or undefined when calling avcTasksBatchGetPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcTasks/$batchGet`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.avcTaskBatchGet,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get audio/video coding tasks in bulk.
     */
    async avcTasksBatchGetPost(requestParameters, initOverrides) {
        const response = await this.avcTasksBatchGetPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a paginated list of audio/video coding tasks. If the filter: \'query\' is used, then the max total return count is limited to 10 000 even with pagination.
     */
    async avcTasksGetRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.environmentId !== undefined) {
            queryParameters['environmentId'] = requestParameters.environmentId;
        }
        if (requestParameters.repositoryId !== undefined) {
            queryParameters['repositoryId'] = requestParameters.repositoryId;
        }
        if (requestParameters.resourceState) {
            queryParameters['resourceState'] = requestParameters.resourceState;
        }
        if (requestParameters.view !== undefined) {
            queryParameters['view'] = requestParameters.view;
        }
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.groups) {
            queryParameters['groups'] = requestParameters.groups;
        }
        if (requestParameters.excludeGrouped !== undefined) {
            queryParameters['excludeGrouped'] = requestParameters.excludeGrouped;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcTasks`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of audio/video coding tasks. If the filter: \'query\' is used, then the max total return count is limited to 10 000 even with pagination.
     */
    async avcTasksGet(requestParameters = {}, initOverrides) {
        const response = await this.avcTasksGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new audio/video coding task.
     */
    async avcTasksPostRaw(requestParameters, initOverrides) {
        if (requestParameters.avcTaskInsert === null ||
            requestParameters.avcTaskInsert === undefined) {
            throw new runtime.RequiredError('avcTaskInsert', 'Required parameter requestParameters.avcTaskInsert was null or undefined when calling avcTasksPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcTasks`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.avcTaskInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new audio/video coding task.
     */
    async avcTasksPost(requestParameters, initOverrides) {
        const response = await this.avcTasksPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete an audio/video coding task.
     */
    async avcTasksTaskIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.taskId === null ||
            requestParameters.taskId === undefined) {
            throw new runtime.RequiredError('taskId', 'Required parameter requestParameters.taskId was null or undefined when calling avcTasksTaskIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcTasks/{taskId}`.replace(`{${'taskId'}}`, String(requestParameters.taskId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete an audio/video coding task.
     */
    async avcTasksTaskIdDelete(requestParameters, initOverrides) {
        await this.avcTasksTaskIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get an audio/video coding task.
     */
    async avcTasksTaskIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.taskId === null ||
            requestParameters.taskId === undefined) {
            throw new runtime.RequiredError('taskId', 'Required parameter requestParameters.taskId was null or undefined when calling avcTasksTaskIdGet.');
        }
        const queryParameters = {};
        if (requestParameters.view !== undefined) {
            queryParameters['view'] = requestParameters.view;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcTasks/{taskId}`.replace(`{${'taskId'}}`, String(requestParameters.taskId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get an audio/video coding task.
     */
    async avcTasksTaskIdGet(requestParameters, initOverrides) {
        const response = await this.avcTasksTaskIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List audio/video task logs.
     */
    async avcTasksTaskIdLogsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.taskId === null ||
            requestParameters.taskId === undefined) {
            throw new runtime.RequiredError('taskId', 'Required parameter requestParameters.taskId was null or undefined when calling avcTasksTaskIdLogsGet.');
        }
        const queryParameters = {};
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }
        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }
        if (requestParameters.levels) {
            queryParameters['levels'] = requestParameters.levels;
        }
        if (requestParameters.types) {
            queryParameters['types'] = requestParameters.types;
        }
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.alertId !== undefined) {
            queryParameters['alertId'] = requestParameters.alertId;
        }
        if (requestParameters.alertCode !== undefined) {
            queryParameters['alertCode'] = requestParameters.alertCode;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcTasks/{taskId}/logs`.replace(`{${'taskId'}}`, String(requestParameters.taskId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * List audio/video task logs.
     */
    async avcTasksTaskIdLogsGet(requestParameters, initOverrides) {
        const response = await this.avcTasksTaskIdLogsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit an audio/video coding task.
     */
    async avcTasksTaskIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.taskId === null ||
            requestParameters.taskId === undefined) {
            throw new runtime.RequiredError('taskId', 'Required parameter requestParameters.taskId was null or undefined when calling avcTasksTaskIdPatch.');
        }
        if (requestParameters.avcTaskEdit === null ||
            requestParameters.avcTaskEdit === undefined) {
            throw new runtime.RequiredError('avcTaskEdit', 'Required parameter requestParameters.avcTaskEdit was null or undefined when calling avcTasksTaskIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcTasks/{taskId}`.replace(`{${'taskId'}}`, String(requestParameters.taskId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.avcTaskEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit an audio/video coding task.
     */
    async avcTasksTaskIdPatch(requestParameters, initOverrides) {
        const response = await this.avcTasksTaskIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete a task schedule entry.
     */
    async avcTasksTaskIdScheduleEntryIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.taskId === null ||
            requestParameters.taskId === undefined) {
            throw new runtime.RequiredError('taskId', 'Required parameter requestParameters.taskId was null or undefined when calling avcTasksTaskIdScheduleEntryIdDelete.');
        }
        if (requestParameters.entryId === null ||
            requestParameters.entryId === undefined) {
            throw new runtime.RequiredError('entryId', 'Required parameter requestParameters.entryId was null or undefined when calling avcTasksTaskIdScheduleEntryIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcTasks/{taskId}/schedule/{entryId}`
                .replace(`{${'taskId'}}`, String(requestParameters.taskId))
                .replace(`{${'entryId'}}`, String(requestParameters.entryId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a task schedule entry.
     */
    async avcTasksTaskIdScheduleEntryIdDelete(requestParameters, initOverrides) {
        await this.avcTasksTaskIdScheduleEntryIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get a task schedule entry.
     */
    async avcTasksTaskIdScheduleEntryIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.taskId === null ||
            requestParameters.taskId === undefined) {
            throw new runtime.RequiredError('taskId', 'Required parameter requestParameters.taskId was null or undefined when calling avcTasksTaskIdScheduleEntryIdGet.');
        }
        if (requestParameters.entryId === null ||
            requestParameters.entryId === undefined) {
            throw new runtime.RequiredError('entryId', 'Required parameter requestParameters.entryId was null or undefined when calling avcTasksTaskIdScheduleEntryIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcTasks/{taskId}/schedule/{entryId}`
                .replace(`{${'taskId'}}`, String(requestParameters.taskId))
                .replace(`{${'entryId'}}`, String(requestParameters.entryId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a task schedule entry.
     */
    async avcTasksTaskIdScheduleEntryIdGet(requestParameters, initOverrides) {
        const response = await this.avcTasksTaskIdScheduleEntryIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit a task schedule entry.
     */
    async avcTasksTaskIdScheduleEntryIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.taskId === null ||
            requestParameters.taskId === undefined) {
            throw new runtime.RequiredError('taskId', 'Required parameter requestParameters.taskId was null or undefined when calling avcTasksTaskIdScheduleEntryIdPatch.');
        }
        if (requestParameters.entryId === null ||
            requestParameters.entryId === undefined) {
            throw new runtime.RequiredError('entryId', 'Required parameter requestParameters.entryId was null or undefined when calling avcTasksTaskIdScheduleEntryIdPatch.');
        }
        if (requestParameters.avcTaskScheduleEntryEdit === null ||
            requestParameters.avcTaskScheduleEntryEdit === undefined) {
            throw new runtime.RequiredError('avcTaskScheduleEntryEdit', 'Required parameter requestParameters.avcTaskScheduleEntryEdit was null or undefined when calling avcTasksTaskIdScheduleEntryIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcTasks/{taskId}/schedule/{entryId}`
                .replace(`{${'taskId'}}`, String(requestParameters.taskId))
                .replace(`{${'entryId'}}`, String(requestParameters.entryId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.avcTaskScheduleEntryEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit a task schedule entry.
     */
    async avcTasksTaskIdScheduleEntryIdPatch(requestParameters, initOverrides) {
        const response = await this.avcTasksTaskIdScheduleEntryIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List task schedule entries.
     */
    async avcTasksTaskIdScheduleGetRaw(requestParameters, initOverrides) {
        if (requestParameters.taskId === null ||
            requestParameters.taskId === undefined) {
            throw new runtime.RequiredError('taskId', 'Required parameter requestParameters.taskId was null or undefined when calling avcTasksTaskIdScheduleGet.');
        }
        const queryParameters = {};
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.timeRangeStart !== undefined) {
            queryParameters['timeRangeStart'] = requestParameters.timeRangeStart;
        }
        if (requestParameters.timeRangeEnd !== undefined) {
            queryParameters['timeRangeEnd'] = requestParameters.timeRangeEnd;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcTasks/{taskId}/schedule`.replace(`{${'taskId'}}`, String(requestParameters.taskId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * List task schedule entries.
     */
    async avcTasksTaskIdScheduleGet(requestParameters, initOverrides) {
        const response = await this.avcTasksTaskIdScheduleGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a task schedule entry.
     */
    async avcTasksTaskIdSchedulePostRaw(requestParameters, initOverrides) {
        if (requestParameters.taskId === null ||
            requestParameters.taskId === undefined) {
            throw new runtime.RequiredError('taskId', 'Required parameter requestParameters.taskId was null or undefined when calling avcTasksTaskIdSchedulePost.');
        }
        if (requestParameters.avcTaskScheduleEntryInsert === null ||
            requestParameters.avcTaskScheduleEntryInsert === undefined) {
            throw new runtime.RequiredError('avcTaskScheduleEntryInsert', 'Required parameter requestParameters.avcTaskScheduleEntryInsert was null or undefined when calling avcTasksTaskIdSchedulePost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcTasks/{taskId}/schedule`.replace(`{${'taskId'}}`, String(requestParameters.taskId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.avcTaskScheduleEntryInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a task schedule entry.
     */
    async avcTasksTaskIdSchedulePost(requestParameters, initOverrides) {
        const response = await this.avcTasksTaskIdSchedulePostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Start an audio/video coding task.
     */
    async avcTasksTaskIdStartPostRaw(requestParameters, initOverrides) {
        if (requestParameters.taskId === null ||
            requestParameters.taskId === undefined) {
            throw new runtime.RequiredError('taskId', 'Required parameter requestParameters.taskId was null or undefined when calling avcTasksTaskIdStartPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcTasks/{taskId}/start`.replace(`{${'taskId'}}`, String(requestParameters.taskId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Start an audio/video coding task.
     */
    async avcTasksTaskIdStartPost(requestParameters, initOverrides) {
        const response = await this.avcTasksTaskIdStartPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Stop an audio/video coding task.
     */
    async avcTasksTaskIdStopPostRaw(requestParameters, initOverrides) {
        if (requestParameters.taskId === null ||
            requestParameters.taskId === undefined) {
            throw new runtime.RequiredError('taskId', 'Required parameter requestParameters.taskId was null or undefined when calling avcTasksTaskIdStopPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcTasks/{taskId}/stop`.replace(`{${'taskId'}}`, String(requestParameters.taskId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Stop an audio/video coding task.
     */
    async avcTasksTaskIdStopPost(requestParameters, initOverrides) {
        const response = await this.avcTasksTaskIdStopPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List the latest audio/video task config versions.
     */
    async avcTasksTaskIdVersionsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.taskId === null ||
            requestParameters.taskId === undefined) {
            throw new runtime.RequiredError('taskId', 'Required parameter requestParameters.taskId was null or undefined when calling avcTasksTaskIdVersionsGet.');
        }
        const queryParameters = {};
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcTasks/{taskId}/versions`.replace(`{${'taskId'}}`, String(requestParameters.taskId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * List the latest audio/video task config versions.
     */
    async avcTasksTaskIdVersionsGet(requestParameters, initOverrides) {
        const response = await this.avcTasksTaskIdVersionsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a specific audio/video task config version.
     */
    async avcTasksTaskIdVersionsVersionIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.taskId === null ||
            requestParameters.taskId === undefined) {
            throw new runtime.RequiredError('taskId', 'Required parameter requestParameters.taskId was null or undefined when calling avcTasksTaskIdVersionsVersionIdGet.');
        }
        if (requestParameters.versionId === null ||
            requestParameters.versionId === undefined) {
            throw new runtime.RequiredError('versionId', 'Required parameter requestParameters.versionId was null or undefined when calling avcTasksTaskIdVersionsVersionIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/avcTasks/{taskId}/versions/{versionId}`
                .replace(`{${'taskId'}}`, String(requestParameters.taskId))
                .replace(`{${'versionId'}}`, String(requestParameters.versionId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a specific audio/video task config version.
     */
    async avcTasksTaskIdVersionsVersionIdGet(requestParameters, initOverrides) {
        const response = await this.avcTasksTaskIdVersionsVersionIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const AvcTasksGetResourceStateEnum = {
    Active: 'ACTIVE',
    Disposed: 'DISPOSED',
    Deleted: 'DELETED',
};
/**
 * @export
 */
export const AvcTasksGetViewEnum = {
    Slim: 'Slim',
    Full: 'Full',
};
/**
 * @export
 */
export const AvcTasksTaskIdGetViewEnum = {
    Slim: 'Slim',
    Full: 'Full',
};
/**
 * @export
 */
export const AvcTasksTaskIdLogsGetLevelsEnum = {
    Info: 'Info',
    Warning: 'Warning',
    Error: 'Error',
    Critical: 'Critical',
};
/**
 * @export
 */
export const AvcTasksTaskIdLogsGetTypesEnum = {
    Log: 'Log',
    AlertCreation: 'AlertCreation',
    AlertUpdate: 'AlertUpdate',
    AlertDeletion: 'AlertDeletion',
};
//# sourceMappingURL=AvcTasksApi.js.map